<ion-header>
  <ion-toolbar>
    <ion-title> Log In Required </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="confirm-wrapper">
    <p>{{ text }}</p>
    <div class="button-wrapper">
      <button type="button" class="cnt-button" (click)="openLoginModal()">Log In</button>
    </div>
  </div>
</ion-content>
